<mat-card>
  <mat-card-header class="justify-content-between align-items-center mb-3">
    <mat-card-title class="fs-5 mb-0">
      Unblock request
    </mat-card-title>
    <button mat-button color="primary" [routerLink]="['/support','unblock-requests']" [skipLocationChange]="true">See more</button>
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="usersList"
      [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
    </sm-data-table>
  </div>
</mat-card>


<ng-template #menuTemplate let-value>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">mail</mat-icon>
    <span>Message</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">verified_user</mat-icon>
    <span>Unblock</span>
  </button>
</ng-template>
